// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: confirm-fade-in 0.15s ease-out;
}

.confirm-dialog {
  width: 100%;
  max-width: 420px;
  background: var(--bg-primary, #ffffff);
  border: 1px solid var(--border-primary, #e5e7eb);
  border-radius: 16px;
  box-shadow: 0 20px 48px -12px rgba(0, 0, 0, 0.35);
  padding: 28px 28px 20px;
  text-align: center;
  animation: confirm-scale-in 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-theme="dark"] .confirm-dialog {
  box-shadow: 0 20px 48px -12px rgba(0, 0, 0, 0.65);
}

.confirm-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary, #f3f4f6);
  color: var(--text-secondary, #6b7280);
}

.confirm-icon.danger {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

[data-theme="dark"] .confirm-icon.danger {
  background: rgba(239, 68, 68, 0.18);
  color: #f87171;
}

.confirm-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary, #111827);
  margin: 0 0 8px 0;
  letter-spacing: -0.01em;
}

.confirm-message {
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary, #6b7280);
  margin: 0 0 24px 0;
}

.confirm-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.confirm-btn {
  flex: 1 1;
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.15s ease, box-shadow 0.15s ease;
  border: 1px solid transparent;
}

.confirm-btn:active {
  transform: translateY(1px);
}

.confirm-btn-cancel {
  background: var(--bg-secondary, #f3f4f6);
  color: var(--text-primary, #111827);
  border-color: var(--border-primary, #e5e7eb);
}

.confirm-btn-cancel:hover {
  background: var(--bg-tertiary, #e5e7eb);
}

[data-theme="dark"] .confirm-btn-cancel {
  background: var(--bg-secondary-dark, #374151);
  color: var(--text-primary-dark, #f9fafb);
  border-color: var(--border-dark, #4b5563);
}

[data-theme="dark"] .confirm-btn-cancel:hover {
  background: var(--bg-tertiary-dark, #4b5563);
}

.confirm-btn-primary {
  background: var(--accent-primary, #2663eb);
  color: #ffffff;
}

.confirm-btn-primary:hover {
  background: var(--accent-secondary, #1d4fc4);
  box-shadow: 0 4px 12px -2px rgba(38, 99, 235, 0.45);
}

.confirm-btn-danger {
  background: #ef4444;
  color: #ffffff;
}

.confirm-btn-danger:hover {
  background: #dc2626;
  box-shadow: 0 4px 12px -2px rgba(239, 68, 68, 0.45);
}

@keyframes confirm-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes confirm-scale-in {
  from { opacity: 0; transform: scale(0.96) translateY(4px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ConfirmDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,gDAAgD;EAChD,mBAAmB;EACnB,iDAAiD;EACjD,uBAAuB;EACvB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8EAA8E;EAC9E,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD","sourcesContent":[".confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  animation: confirm-fade-in 0.15s ease-out;\n}\n\n.confirm-dialog {\n  width: 100%;\n  max-width: 420px;\n  background: var(--bg-primary, #ffffff);\n  border: 1px solid var(--border-primary, #e5e7eb);\n  border-radius: 16px;\n  box-shadow: 0 20px 48px -12px rgba(0, 0, 0, 0.35);\n  padding: 28px 28px 20px;\n  text-align: center;\n  animation: confirm-scale-in 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n[data-theme=\"dark\"] .confirm-dialog {\n  box-shadow: 0 20px 48px -12px rgba(0, 0, 0, 0.65);\n}\n\n.confirm-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  margin: 0 auto 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary, #f3f4f6);\n  color: var(--text-secondary, #6b7280);\n}\n\n.confirm-icon.danger {\n  background: rgba(239, 68, 68, 0.12);\n  color: #ef4444;\n}\n\n[data-theme=\"dark\"] .confirm-icon.danger {\n  background: rgba(239, 68, 68, 0.18);\n  color: #f87171;\n}\n\n.confirm-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary, #111827);\n  margin: 0 0 8px 0;\n  letter-spacing: -0.01em;\n}\n\n.confirm-message {\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--text-secondary, #6b7280);\n  margin: 0 0 24px 0;\n}\n\n.confirm-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n}\n\n.confirm-btn {\n  flex: 1;\n  padding: 10px 18px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.12s ease, background 0.15s ease, box-shadow 0.15s ease;\n  border: 1px solid transparent;\n}\n\n.confirm-btn:active {\n  transform: translateY(1px);\n}\n\n.confirm-btn-cancel {\n  background: var(--bg-secondary, #f3f4f6);\n  color: var(--text-primary, #111827);\n  border-color: var(--border-primary, #e5e7eb);\n}\n\n.confirm-btn-cancel:hover {\n  background: var(--bg-tertiary, #e5e7eb);\n}\n\n[data-theme=\"dark\"] .confirm-btn-cancel {\n  background: var(--bg-secondary-dark, #374151);\n  color: var(--text-primary-dark, #f9fafb);\n  border-color: var(--border-dark, #4b5563);\n}\n\n[data-theme=\"dark\"] .confirm-btn-cancel:hover {\n  background: var(--bg-tertiary-dark, #4b5563);\n}\n\n.confirm-btn-primary {\n  background: var(--accent-primary, #2663eb);\n  color: #ffffff;\n}\n\n.confirm-btn-primary:hover {\n  background: var(--accent-secondary, #1d4fc4);\n  box-shadow: 0 4px 12px -2px rgba(38, 99, 235, 0.45);\n}\n\n.confirm-btn-danger {\n  background: #ef4444;\n  color: #ffffff;\n}\n\n.confirm-btn-danger:hover {\n  background: #dc2626;\n  box-shadow: 0 4px 12px -2px rgba(239, 68, 68, 0.45);\n}\n\n@keyframes confirm-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes confirm-scale-in {\n  from { opacity: 0; transform: scale(0.96) translateY(4px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
